




import { Component, Vue } from "vue-property-decorator";
import RoomList from "@/containers/RoomList.vue";

@Component({
  components: {
    RoomList
  }
})
export default class BuildingDetails extends Vue {}
